import commonUtils from './utils'
import Storage from './localStorage'

const install = function (Vue) {
  Vue.prototype.$utils = commonUtils
  Vue.prototype.$storage = Storage
}
export default install



// WEBPACK FOOTER //
// ./src/common/index.js